import React from "react";
import {
  X,
  ShieldAlert,
  ShieldCheck
} from "lucide-react";
import "../../../../assets/css/components/serviceprovider/dashboard/workernavbar/KycRequiredModal.css";

const KycRequiredModal = ({
  isOpen,
  onClose,
  onCompleteKyc
}) => {

  if (!isOpen) return null;

  return (
    <div
      className="krm-overlay"
      onClick={onClose}
    >
      <div
        className="krm-modal"
        onClick={(e) => e.stopPropagation()}
      >

        <button
          className="krm-close"
          onClick={onClose}
        >
          <X size={18} />
        </button>

        <div className="krm-icon">
          <ShieldAlert size={38} strokeWidth={2.2} />
        </div>

        <h2 className="krm-title">
          KYC Approval Required
        </h2>

        <p className="krm-text">
          Your KYC verification hasn't been approved yet.
          Complete your verification to unlock all Responder
          features, receive job requests and start earning.
        </p>

        <div className="krm-actions">

          <button
            className="krm-btn krm-btn-secondary"
            onClick={onClose}
          >
            Maybe Later
          </button>

          <button
            className="krm-btn krm-btn-primary"
            onClick={onCompleteKyc}
          >
            <ShieldCheck size={18} />
            Complete KYC
          </button>

        </div>

      </div>
    </div>
  );
};

export default KycRequiredModal;